import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { useRevealOnScroll } from '../../ui';

// Owner-confirmed 2026-07-04: $29/mo (HLD §6 ruling)
const PRO_PRICE_MONTHLY = '$29';

const includedFeatures = [
  'Full AI coaching access, every day of the week',
  'Training and nutrition plans built around your life',
  'Workout and food logging in plain language',
  'Progress tracking that tightens each week’s plan',
];

export function Pricing() {
  const cardRef = useRevealOnScroll<HTMLDivElement>();
  return (
    <section id="pricing" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="section-eyebrow">Pricing</p>
          <h2 className="section-title">
            One plan. Try it free for a week.
          </h2>
          <p className="section-copy mx-auto">
            Everything is included from day one — no tiers to compare, no features held back. Take seven days to see whether the coaching actually fits your life.
          </p>
        </div>

        <div ref={cardRef} className="reveal-on-scroll mx-auto max-w-xl">
          <div
            className="app-panel p-8 sm:p-10"
            style={{
              border: '1px solid var(--color-brand-soft)',
              background:
                'linear-gradient(155deg, var(--color-brand), var(--color-brand-strong))',
              color: 'var(--color-on-brand)',
              boxShadow: 'var(--shadow-lifted)',
            }}
          >
            <span
              className="app-chip"
              style={{
                background: 'color-mix(in srgb, var(--color-on-brand) 14%, transparent)',
                borderColor: 'color-mix(in srgb, var(--color-on-brand) 28%, transparent)',
                color: 'var(--color-on-brand)',
              }}
            >
              7-day free trial
            </span>

            <div className="mt-6 flex items-baseline">
              <span
                className="text-5xl font-bold tracking-tight"
                style={{ color: 'var(--color-on-brand)' }}
              >
                {PRO_PRICE_MONTHLY}
              </span>
              <span
                className="ml-2 text-lg"
                style={{ color: 'color-mix(in srgb, var(--color-on-brand) 82%, transparent)' }}
              >
                /mo after trial
              </span>
            </div>
            <p
              className="mt-3"
              style={{ color: 'color-mix(in srgb, var(--color-on-brand) 82%, transparent)' }}
            >
              A week of real coaching before you pay anything — the same assistant, plans, and logging you get as a member.
            </p>

            <ul className="mt-8 space-y-4">
              {includedFeatures.map((feature) => (
                <li key={feature} className="flex items-start gap-3">
                  <Check
                    className="h-5 w-5 flex-shrink-0"
                    style={{ color: 'color-mix(in srgb, var(--color-on-brand) 88%, transparent)' }}
                  />
                  <span
                    style={{ color: 'color-mix(in srgb, var(--color-on-brand) 88%, transparent)' }}
                  >
                    {feature}
                  </span>
                </li>
              ))}
            </ul>

            <Link
              to="/start"
              className="app-button app-button--block mt-8"
              style={{
                background: 'var(--color-on-brand)',
                color: 'var(--color-brand)',
                borderColor: 'transparent',
              }}
            >
              Start Your 7-Day Free Trial
              <ArrowRight className="h-4 w-4" />
            </Link>
            <p
              className="mt-4 text-center text-sm leading-6"
              style={{ color: 'color-mix(in srgb, var(--color-on-brand) 72%, transparent)' }}
            >
              Card required to start. Your plan continues automatically after the trial — cancel anytime before it ends.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
